document.addEventListener('alpine:init', () => {
  Alpine.store('utilities', {
    getElsFromHtmlString,
    getElFromHtmlString,
    removeSectionWrapper,
    getScript,
    getStylesheet,
    formatMoney,
    randomUUID
  });

  function getElsFromHtmlString(htmlString, selector) {
    var parser = new DOMParser();
    var parserDocument = parser.parseFromString(htmlString, 'text/html');
  
    return parserDocument.querySelectorAll(selector);
  };

  function getElFromHtmlString(htmlString, selector) {
    return getElsFromHtmlString(htmlString, selector)[0];
  };

  function removeSectionWrapper(htmlString) {
    var parser = new DOMParser();
    var parserDocument = parser.parseFromString(htmlString, 'text/html');
  
    return parserDocument.body.firstElementChild.innerHTML;
  };

  function getScript(source, callback) {
    var script = document.createElement('script');
    var prior = document.getElementsByTagName('script')[0];
  
    script.onload = script.onreadystatechange = (_, isAbort) => {
      if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
        script.onload = script.onreadystatechange = null;
        script = undefined;
        if (!isAbort) if (callback) callback();
      }
    };
  
    script.src = source;
    prior.parentNode.insertBefore(script, prior);
  };

  function getStylesheet(source, callback) {  
    var head = document.getElementsByTagName('head')[0];

    var style = document.createElement('link');

    style.href = source;
    style.type = 'text/css';
    style.rel = 'stylesheet';

    head.append(style); 

    if (callback) callback();
  };

  function formatMoney(cents, format) {
    const moneyFormat = window.global.shop.moneyFormat;

    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(
      number,
      precision = 2,
      thousands = ',',
      decimal = '.'
    ) {
      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        `$1${thousands}`
      );
      const centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  function randomUUID() {
    return crypto.randomUUID();
  };
});
